import React, { forwardRef } from 'react';
import {
    Table, Typography, Row, Col
} from 'antd';
import locale from 'antd/es/locale/pt_BR';

// @ts-ignore
import ImagemLogo from '../../../../../../assets/logo.png';
import { convertMoedaUSParaBRInicioSemDigitos } from '../../../../../../services/Conversores';

const { Text, Title } = Typography;

interface IProps {
    columns: any[];
    dataSource: any[];
    loading: boolean;
    refContagemDoFiltro: React.MutableRefObject<any[]>;
    propsState: any;
}

const TableWrapperPrint = forwardRef<any, IProps>(({
    columns,
    dataSource,
    loading,
    refContagemDoFiltro,
    propsState
}, ref) => {
    return (
        <div ref={ref} className="tableRelatorioListUsuario_wrapper report-content">
            <Row className="header-report" justify={'space-between'}>
                <Col className="header-info">
                    <h1>Listagem de Usuários</h1>
                </Col>
                <Col className="header-logo">
                    <img
                        src={ImagemLogo}
                        alt="Icone"
                    />
                </Col>
            </Row>

            <div className="page">
                <Table
                    className="tableRelatorioListUsuario_print"
                    rowKey={(record) => record.uuid}
                    loading={loading}
                    columns={columns}
                    dataSource={dataSource}
                    size="small"
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource;
                        }
                    }
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: false,
                        pageSize: dataSource.length + 10,
                        position: [],
                        pageSizeOptions: []
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: 'end'
                                }}
                            >
                                <Text>
                                    {`Total de ${convertMoedaUSParaBRInicioSemDigitos(dataSource.length.toString())} registros.`}
                                </Text>
                            </div>
                        )
                    }}
                    locale={locale.Table}
                />
            </div>

            <div className="footer-report">
                <div>
                    <img
                        width={'200px'}
                        style={{ padding: '15px' }}
                        src={ImagemLogo}
                        alt="Logo do Sistema"
                        className="logo-img"
                    />
                </div>
                <div className="footer-report-date-generated">
                    <p>
                        Arquivo gerado em {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR", {
                            hour: "2-digit",
                            minute: "2-digit"
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
});

TableWrapperPrint.displayName = 'TableWrapperPrint';

export default TableWrapperPrint;
